import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'submenu_tab_id',
    viewPath: props.viewPath,
  })
  let menu_item_id = useDataValue({
    context: 'menu_item',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(menu_item_id)
  }
}
